var server = "https://psmdoc.gestionciudad.com";
var wsServer = "wss://psmdoc.gestionciudad.com";
if (process.env.NODE_ENV === "development") {
  server = "http://localhost:8007";
  wsServer = "ws://localhost:8007";
}

const appName = "PSMDoc";
const localStorageVars = {
  storageName: "psmdoc",
  token: "tk",
};

export { server, localStorageVars, wsServer, appName };
